import { render, staticRenderFns } from "./TheMainHeader.vue?vue&type=template&id=430e5344&scoped=true"
import script from "./TheMainHeader.vue?vue&type=script&lang=js"
export * from "./TheMainHeader.vue?vue&type=script&lang=js"
import style0 from "./TheMainHeader.vue?vue&type=style&index=0&id=430e5344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430e5344",
  null
  
)

export default component.exports